import { inject } from 'aurelia-framework';
import { QuoteService } from 'pages/quotes/service';
import moment from 'moment';

import 'pages/quotes/print/styles.scss';

@inject(QuoteService)
export class Print {
    constructor(quoteService) {
        this.quoteService = quoteService;

        this.currentDate = moment().format('M/D/YYYY');
    }

    async activate(params) {
        if (params.snapshotId && params.id) {
            this.quotes = await this.quoteService.printSnapshot(params.id, params.snapshotId);
        } else if (params.id) {
            this.quotes = await this.quoteService.print(params.id);
        } else {
            const filter = JSON.parse(window.localStorage.getItem('printFilter'));
            this.quotes = await this.quoteService.massPrint(filter);
        }
    }

    attached() {
        window.print();
    }

    deactivate() {
        window.localStorage.removeItem('printFilter');
    }

    getStructure(quote, index) {
        const structure = quote.structure[index];
        if (structure == null) {
            return {
                partNumber: '',
                weight: '',
                partType: '',
                manufacturingLocation: '',
                quantity: '',
                unitPrice: null,
                total: null
            };
        }

        if (structure.weight == 0) {
            structure.weight = 'N/A';
        }

        if (structure.manufacturingLocation == null) {
            structure.manufacturingLocation = structure.purchaseItemType;
        }

        return structure;
    }

    getProcess(quote, index) {
        const process = quote.processes[index];
        if (process == null) {
            return {
                workCenter: '',
                processName: '',
                machineName: '',
                stageName: '',
                quantity: null,
                unitPrice: null,
                total: null
            };
        }

        process.total = process.total == null || parseFloat(process.total) == 0 ? 0 : parseFloat(process.total).toFixed(4);
        return process;
    }

    getBlankSize(rawMaterial) {
        if (rawMaterial == null || rawMaterial.thickness == null) return '';

        return `${rawMaterial.blankLength} X ${rawMaterial.blankWidth} X ${rawMaterial.thickness.toFixed(2)}`;
    }

    getGrossWeight(rawMaterial) {
        if (rawMaterial == null || rawMaterial.blankLength == null) return '';

        return (((rawMaterial.blankLength * rawMaterial.blankWidth * rawMaterial.thickness * rawMaterial.gravity) / 1000000) / rawMaterial.numberOut).toFixed(4);
    }

    getRMYield(rawMaterial) {
        if (rawMaterial == null || rawMaterial.netWeight == null) return '';

        return `${((rawMaterial.netWeight / this.getGrossWeight(rawMaterial)) * 100).toFixed(2)}%`;
    }

    getScrapWeight(rawMaterial) {
        if (rawMaterial == null || rawMaterial.netWeight == null) return '';

        return (this.getGrossWeight(rawMaterial) - rawMaterial.netWeight).toFixed(4);
    }

    getScrapCredit(rawMaterial) {
        if (rawMaterial == null || rawMaterial.scrapUnitPriceOverride == null) return '';

        return (this.getScrapWeight(rawMaterial) * rawMaterial.scrapUnitPriceOverride).toFixed(4);
    }

    getBlankPrice(rawMaterial) {
        if (rawMaterial == null || rawMaterial.price == null) return '';

        return (this.getGrossWeight(rawMaterial) * rawMaterial.price).toFixed(4);
    }

    truncateComment(comment) {
        if (comment != null && comment.length > 110) {
            return comment.substring(0, 110).trim() + '...';
        }

        return comment;
    }
}